import React from 'react'
import { Link } from 'react-router-dom'
import { Box, Button, Typography } from '@mui/material'

import { images } from '~assets/images'
import { Image } from '~components/common'
import Page from '~components/layout/Page'

const PageNotFoundScreen: React.FC<{ permissionsError: boolean }> = ({ permissionsError }) => {
  const getErrorTitle = (): string => {
    if (permissionsError) {
      return 'Page Not Available'
    } else {
      return 'Page Not Found'
    }
  }

  const getErrorDescription = (): React.ReactNode => {
    if (permissionsError) {
      return "You don't seem to have permissions for this organization. Please reach out to your administrator if you need access"
    } else {
      return (
        <>
          Uh oh, we can't seem to find the page you're looking for.
          <br />
          Try going back to the previous page
        </>
      )
    }
  }

  return (
    <Page
      padding={0}
      hideMenu={!permissionsError}
      style={{ height: '100vh', width: '100%', overflow: 'hidden', margin: 0 }}
    >
      <Box
        display='flex'
        flexDirection='column'
        height='100%'
        width='100%'
        style={{
          position: 'absolute', // Position absolutely to fill the page
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        }}
      >
        <Box display='flex' width='100%' height='27%'>
          <Box position='absolute' right='0' top='0'>
            <Image src={images.greenBlob} alt='Green blob' size='450px' />
          </Box>
        </Box>
        <Box className='flex-vh-align' width='100%' gap={10} flexDirection='column'>
          <Typography fontSize='48px' textAlign='center'>
            {getErrorTitle()}
          </Typography>
          <Typography variant='h2' maxWidth='900px' textAlign='center'>
            {getErrorDescription()}
          </Typography>
          <Button
            component={Link}
            to='/'
            variant='contained'
            color='secondary'
            sx={{
              py: 1.5,
              mb: 2,
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: 600,
              textTransform: 'none',
            }}
          >
            Back to Home
          </Button>
        </Box>
        <Box flexGrow={1} />
        <Box className='flex-vh-align' width='100%'>
          <Box position='absolute' left='0' bottom='-5px'>
            <Image
              src={permissionsError ? images.blueBlob : images.titaniumBlob}
              alt='Titanium blob'
              size='450px'
            />
          </Box>
          <Image
            src={images.quietStreetGraphic}
            alt='Quiet Street Graphic'
            width='45%'
            height='100%'
            sx={{ marginBottom: '30px' }}
          />
        </Box>
      </Box>
    </Page>
  )
}

export default PageNotFoundScreen
